<template>
<div>
  <b-container fluid v-if="!isOwner && !$apollo.queries.companyLead._loading">
    <b-row>
      <b-col>
        <AccessDenied />
      </b-col>
    </b-row>
  </b-container>
  <b-container fluid v-if="companyLead && isOwner">
    <FormulateForm
      name="editCompanyLead"
      #default="{ isLoading }"
      v-model="formValues"
    >
      <b-row>
        <b-col sm="12">
          <iq-card body-class="profile-page p-0">
            <template v-slot:body>
              <div class="profile-header">
                <div class="profile-info p-4">
                  <b-row>
                    <b-col>
                      <b-row>
                        <b-col>
                          <h2>
                            {{ companyLead.company.name }}
                          </h2>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <div class="user-detail">
                            <div class="d-flex flex-wrap">
                              <div>
                                <span class="d-block">
                                  <strong>campaign:</strong>
                                  {{ companyLead.campaign.name }}
                                </span>
                                <span class="d-block">
                                  <strong>CX:</strong>
                                  {{ companyLead.company.contacts_aggregate.aggregate.max.cx}}
                                </span>
                              </div>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col class="d-flex flex-direction-column justify-content-end">
                      <div class="stage-container">
                        <h1>
                            <b-button-group>
                              <b-dropdown
                                :variant="stageVariant"
                                :text="$t(`lead.stage.${companyLead.stage_id}`)"
                                data-cy="stage-select"
                                size="lg"
                              >
                                <b-dropdown-item
                                  v-for="stageOption in stageOptions"
                                  :key="stageOption.value"
                                  @click="
                                    () => stageChangeClickHandler(stageOption.value)
                                  "
                                  >{{ stageOption.label }}</b-dropdown-item
                                >
                              </b-dropdown>
                            </b-button-group>
                          </h1>
                          <div v-if="companyLead.next_best_action">
                            <p class="m-0"><small>next best action</small></p>
                            <h2><b-badge variant="warning">{{companyLead.next_best_action.name }}</b-badge></h2>
                          </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <iq-card>
            <template v-slot:body>
              <b-row>
                <b-col class="d-flex flex-row justify-content-between">
                  <h4 class="card-title d-inline">Contacts in company</h4>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-table-simple responsive>
                    <b-thead>
                      <b-th>Name</b-th>
                      <b-th>Title</b-th>
                      <b-th>Email</b-th>
                      <b-th>Phone</b-th>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="contact in companyLead.company.contacts" :key="contact.id">
                        <b-td>{{ contact.first_name + ' ' + contact.last_name }}</b-td>
                        <b-td>{{ contact.title | notAvailable }}</b-td>
                        <b-td>
                          <a :href="'mailto:' + contact.email">{{ contact.email | notAvailable}}</a>
                        </b-td>
                        <b-td>
                          <a :href="'tel:' + contact.phone">{{ contact.phone | notAvailable}}</a>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <iq-card>
            <template v-slot:body>
              <div class="d-flex align-items-center justify-content-between">
                <h6>
                  Deal value
                  <small v-if="companyLead.target_deal_value"
                    >(target: {{ companyLead.target_deal_value }} $)</small
                  >
                </h6>
                <span class="iq-icon">
                  <i class="ri-information-fill"></i>
                </span>
              </div>
              <div
                class="
                  iq-customer-box
                  d-flex
                  align-items-center
                  justify-content-between
                  mt-3
                "
              >
                <div class="d-flex align-items-center">
                  <div class="rounded-circle iq-card-icon iq-bg-success mr-2">
                    <i class="ri-inbox-fill"></i>
                  </div>
                  <h3>
                    <FormulateInput
                      id="dealValue"
                      name="dealValue"
                      type="text"
                      input-class="form-control"
                      class="mb-0"
                      @change="dealValueChangeHandler"
                      style="
                         {
                          width: '5rem';
                        }
                      "
                    />
                  </h3>
                </div>
                <div class="iq-map text-primary font-size-32">
                  <i class="ri-bar-chart-grouped-line"></i>
                </div>
              </div>
            </template>
          </iq-card>
        </b-col>
        <b-col>
          <iq-card>
            <template v-slot:body>
              <div class="d-flex align-items-center justify-content-between">
                <h6>Priority Index</h6>
                <span class="iq-icon">
                  <i class="ri-information-fill"></i>
                </span>
              </div>
              <div
                class="
                  iq-customer-box
                  d-flex
                  align-items-center
                  justify-content-between
                  mt-3
                "
              >
                <div class="d-flex align-items-center">
                  <div class="rounded-circle iq-card-icon iq-bg-danger mr-2">
                    <i class="ri-inbox-fill"></i>
                  </div>
                  <h3 data-cy="priority-index-label">
                    {{ companyLead.priority_index }}
                  </h3>
                </div>
                <div class="iq-map text-primary font-size-32">
                  <i class="ri-bar-chart-grouped-line"></i>
                </div>
              </div>
            </template>
          </iq-card>
        </b-col>
        <b-col>
          <iq-card>
            <template v-slot:body>
              <div class="d-flex align-items-center justify-content-between">
                <h6>Cluster</h6>
                <span class="iq-icon">
                  <i class="ri-information-fill"></i>
                </span>
              </div>
              <div
                class="
                  iq-customer-box
                  d-flex
                  align-items-center
                  justify-content-between
                  mt-3
                "
              >
                <div class="d-flex align-items-center">
                  <div class="rounded-circle iq-card-icon iq-bg-warning mr-2">
                    <i class="ri-inbox-fill"></i>
                  </div>
                  <h3>{{ companyLead.cluster }}</h3>
                </div>
                <div class="iq-map text-primary font-size-32">
                  <i class="ri-bar-chart-grouped-line"></i>
                </div>
              </div>
            </template>
          </iq-card>
        </b-col>
        <b-col>
          <iq-card>
            <template v-slot:body>
              <div class="d-flex align-items-center justify-content-between">
                <h6>Last activity</h6>
                <span class="iq-icon">
                  <i class="ri-information-fill"></i>
                </span>
              </div>
              <div
                class="
                  iq-customer-box
                  d-flex
                  align-items-center
                  justify-content-between
                  mt-3
                "
              >
                <div class="d-flex align-items-center">
                  <div class="rounded-circle iq-card-icon iq-bg-info mr-2">
                    <i class="ri-inbox-fill"></i>
                  </div>
                  <h3>{{ companyLead.last_activity | formatDate }}</h3>
                </div>
                <div class="iq-map text-primary font-size-32">
                  <i class="ri-bar-chart-grouped-line"></i>
                </div>
              </div>
            </template>
          </iq-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6">
          <iq-card>
            <template v-slot:body>
              <b-row>
                <b-col class="d-flex flex-row justify-content-between">
                  <h4 class="card-title d-inline">Products</h4>
                  <span v-if="updatingProducts">
                    <i class="fas fa-spinner fa-spin ml-2 text-right"></i>
                    saving
                  </span>
                </b-col>
                <!-- <b-col class="text-right">
                  <b-button
                    variant="success"
                    @click="productsChangeHandler"
                    style="width: 150px"
                  >
                    <span v-if="!updatingProducts">Save changes</span>
                    <i
                      v-if="updatingProducts"
                      class="fas fa-spinner fa-spin ml-2"
                    ></i>
                  </b-button>
                </b-col> -->
              </b-row>
              <b-row>
                <b-col>
                  <label>Groups</label>
                  <b-form-row>
                    <b-col>
                      <b-form-group>
                        <template v-for="item in productGroups">
                          <b-checkbox
                            class="custom-switch-color"
                            :color="item.color"
                            v-model="item.checked"
                            :disabled="updatingProducts"
                            name="check-button"
                            :key="item.id"
                            @change="handleProductChange"
                            >{{ item.name }}</b-checkbox
                          >
                        </template>
                      </b-form-group>
                    </b-col>
                  </b-form-row>
                </b-col>
                <b-col>
                  <b-form-group
                    label="Description"
                    label-for="exampleFormControlTextarea1"
                  >
                    <b-form-textarea
                      id="exampleFormControlTextarea1"
                      rows="5"
                      value="asdasd"
                      style="line-height: 15px"
                      :disabled="updatingProducts"
                      @change="handleProductChange"
                      v-model="formValues.productDescription"
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </iq-card>
        </b-col>
        <b-col>
          <iq-card>
            <template v-slot:headerTitle>
              <h4 class="card-title">History timeline</h4>
            </template>
            <template v-slot:headerAction>
              <b-dropdown id="dropdownMenuButton5" right variant="none">
                <template v-slot:button-content>
                  <!-- <span class="text-primary">View All</span> -->
                </template>
                <b-dropdown-item href="#">
                  <i class="ri-eye-fill mr-2"></i>View
                </b-dropdown-item>
                <b-dropdown-item href="#">
                  <i class="ri-close-circle-line mr-2"></i>Delete
                </b-dropdown-item>
                <b-dropdown-item href="#">
                  <i class="ri-pencil-fill mr-2"></i>Edit
                </b-dropdown-item>
                <b-dropdown-item href="#">
                  <i class="ri-printer-fill mr-2"></i>Print
                </b-dropdown-item>
                <b-dropdown-item href="#">
                  <i class="ri-file-download-fill mr-2"></i>Download
                </b-dropdown-item>
              </b-dropdown>
            </template>
            <template v-slot:body>
              <TimeLine :events="events" />
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </FormulateForm>
    <b-modal
      id="stage-change-modal"
      title="Change stage"
      hide-footer
      v-model="showStageChangeModal"
    >
      <FormulateForm
        name="updateStageWithAction"
        v-model="updateStageWithActionFormValues"
      >
        <b-row>
          <b-col>
            <p>What action lead to change:</p>
            <b-form-group class="mb-0">
                    <FormulateInput
                      id="actionId"
                      name="actionId"
                      type="select"
                      placeholder="Choose action"
                      :options="
                        actionOptions.map((c) => ({
                          value: c.id,
                          label: c.name,
                        }))
                      "
                    />
              </b-form-group>
          </b-col>
          <b-col>
            <p>New stage:</p>
            <b-form-group class="mb-0">
                    <FormulateInput
                      id="stageId"
                      name="stageId"
                      type="select"
                      validation="required"
                      placeholder="Choose stage"
                      :options="
                        stageOptions.map((c) => ({
                          value: c.value,
                          label: c.label,
                        }))
                      "
                    />
              </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-4">
          <b-col>
            <b-button
              block
              variant="success"
              class="mb-3 mr-1"
              @click="updateStageWithAction"
              >Record action & Update stage</b-button
            >
          </b-col>
        </b-row>
      </FormulateForm>
      
    </b-modal>
  </b-container>
</div>
</template>
<script>
import { core } from "../../config/pluginInit";
import SocialPost from "./Components/SocialPost";
import AddSocialPost from "./Components/AddSocialPost";
import gql from "graphql-tag";
import { getAccountSync } from "../../Utils/account";
import AccessDenied from './Components/AccessDenied.vue';

const GET_COMPANY_LEAD = gql`
  query getCompanyLead($id: uuid!) {
    company_leads_by_pk(id: $id) {
      id
      owner_id
      company {
        id
        name
        contacts_aggregate {
          aggregate {
            max {
              cx
            }
          }
        }
        contacts {
          id
          first_name
          last_name
          title
          email
          phone
        }
      }
      next_best_action {
        id
        name
      }
      campaign {
        id
        name
        target_deal_value
      }
      stage_id
      deal_value
      target_deal_value
      cluster
      updated_at
      last_activity
      priority_index
      product_description
      company_lead_product_groups {
        id
        company_lead_id
        product_group_id
        product_group {
          id
          name
        }
      }
    }
    product_groups {
      id
      name
    }
  }
`;
const LIST_EVENTS = gql`
  query listEvents($companyLeadId: uuid!) {
    events(
      where: {
        lead: {
          company_lead_id: {
            _eq: $companyLeadId
          }
        }
      }
    ) {
      id
      event_type
      data
      created_at
    }
  }
`;
const LIST_ACTIONS = gql`
  query listActions {
    actions {
      id
      name
    }
  }
`;
const UPDATE_COMPANY_LEAD_STAGE_ACTION = gql`
  mutation updateCompanyLeadStageAction($companyLeadId: uuid!, $newStageId: Int!, $loggedActionId: uuid) {
    updateCompanyLeadStage(
      companyLeadId: $companyLeadId,
      newStageId: $newStageId,
      loggedActionId: $loggedActionId
    ) {
      companyLeadId
    }
  }
`;
const UPDATE_COMPANY_LEAD_DEAL_VALUE = gql`
  mutation updateCompanyLeadDealValue($id: uuid!, $dealValue: float8!) {
    update_company_leads_by_pk(
      pk_columns: { id: $id }
      _set: { deal_value: $dealValue }
    ) {
      id
      deal_value
    }
  }
`;
const UPDATE_COMPANY_LEAD_PRODUCTS = gql`
  mutation updateCompanyLeadProducts(
    $id: uuid!
    $productDescription: String
    $toDeleteCompanyLeadProductGroups: [uuid!]
    $toInsertCompanyLeadProductGroups: [company_lead_product_group_insert_input!]!
  ) {
    delete_company_lead_product_group(
      where: { id: { _in: $toDeleteCompanyLeadProductGroups } }
    ) {
      affected_rows
    }
    insert_company_lead_product_group(objects: $toInsertCompanyLeadProductGroups) {
      affected_rows
    }
    update_company_leads_by_pk(
      pk_columns: { id: $id }
      _set: { product_description: $productDescription }
    ) {
      id
      product_description
      company_lead_product_groups {
        id
        company_lead_id
        product_group_id
        product_group {
          id
          name
        }
      }
    }
  }
`;

export default {
  name: "CompanyLeadsDetail",
  components: { AddSocialPost, SocialPost, AccessDenied },
  mounted() {
    core.index();
  },
  data() {
    return {
      formValues: {
        dealValue: "",
        stageId: "",
        productDescription: ""
      },
      updateStageWithActionFormValues: {
        actionId: "",
        stageId: "",
      },
      showStageChangeModal: false,
      productGroups: [],
      companyLead: null,
      stageOptions: [
        {
          value: 100,
          label: "Qualified"
        },
        {
          value: 200,
          label: "Contacted"
        },
        {
          value: 300,
          label: "Met"
        },
        {
          value: 400,
          label: "Negotiating"
        },
        {
          value: 500,
          label: "Won"
        }
      ],
      actionOptions: [],
      user: {
        profile: require("../../assets/images/user/user-11.png")
      },
      updatingProducts: false,
      account: getAccountSync(),
    };
  },
  apollo: {
    companyLead() {
      return {
        query: GET_COMPANY_LEAD,
        fetchPolicy: "cache-and-network",
        notifyOnNetworkStatusChange: true,
        variables: {
          id: this.$route.params.id
        },
        update: data => {
          this.formValues.dealValue = data.company_leads_by_pk.deal_value;
          this.formValues.stage_id = data.company_leads_by_pk.stage_id;
          this.formValues.productDescription =
            data.company_leads_by_pk.product_description;
          const productGroups = data.product_groups.map(i => ({
            id: i.id,
            name: i.name,
            company_lead_product_group_id:
              data.company_leads_by_pk.company_lead_product_groups.find(
                g => g.product_group.id === i.id
              )?.id || undefined,
            checked: data.company_leads_by_pk.company_lead_product_groups.find(
              g => g.product_group.id === i.id
            )
              ? true
              : false
          }));
          this.productGroups = productGroups;
          return data.company_leads_by_pk;
        }
      };
    },
    events() {
      return {
        query: LIST_EVENTS,
        variables: {
          companyLeadId: this.$route.params.id
        }
      };
    },
    actions() {
      return {
        query: LIST_ACTIONS,
        result({ data, loading, networkStatus }) {
          if (!loading) {
            this.actionOptions = data.actions;
          }
        }
      }
    }
  },
  computed: {
    stageVariant() {
      switch (this.companyLead.stage_id) {
        case 100:
          return "info";
        case 200:
          return "warning";
        case 300:
          return "primary";
        case 400:
          return "danger";
        case 500:
          return "success";
        default:
          return "secondary";
      }
    },
    isOwner(){
      if (this?.companyLead?.owner_id === this?.account?.userId) {
        return true
      }
      return false
    }
  },
  methods: {
    addPost(post) {
      this.socialPosts.unshift(post);
    },
    async updateStageWithAction(){
       try {
        await this.$apollo.mutate({
          mutation: UPDATE_COMPANY_LEAD_STAGE_ACTION,
          variables: {
            companyLeadId: this.$route.params.id,
            newStageId: parseInt(this.updateStageWithActionFormValues.stageId),
            loggedActionId: this.updateStageWithActionFormValues.actionId
          }
        });
        this.$toast.success(`Stage changed`);
        this.showStageChangeModal = false;
        this.$apollo.queries.companyLead.refetch();
      } catch (error) {
        this.$toast.error(`Failed to change stage: ${error.message}`);
      }
    },
    async stageChangeClickHandler(newStageId) {
      this.updateStageWithActionFormValues.stageId = newStageId;
      this.updateStageWithActionFormValues.actionId = this.companyLead.next_best_action?.id;
      this.showStageChangeModal = true;
      setTimeout(() => {
        console.log(document.getElementById("actionId").focus())
      },0)
    },
    async dealValueChangeHandler(e) {
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_COMPANY_LEAD_DEAL_VALUE,
          variables: {
            id: this.$route.params.id,
            dealValue: e.target.value !== "" ? e.target.value : null
          }
        });
        this.$toast.success(`Deal value changed `);
      } catch (error) {
        this.$toast.error(`Failed to change deal value: ${error.message}`);
      }
    },
    async productsChangeHandler(e) {
      this.updatingProducts = true;
      const toDeleteCompanyLeadProductGroups = this.productGroups
        .filter(
          i => i.checked === false && i.company_lead_product_group_id !== undefined
        )
        .map(i => i.company_lead_product_group_id);
      const toInsertCompanyLeadProductGroups = this.productGroups
        .filter(
          i => i.checked === true && i.company_lead_product_group_id === undefined
        )
        .map(i => ({
          company_lead_id: this.$route.params.id,
          product_group_id: i.id
        }));
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_COMPANY_LEAD_PRODUCTS,
          variables: {
            id: this.$route.params.id,
            productDescription: this.formValues.productDescription,
            toDeleteCompanyLeadProductGroups,
            toInsertCompanyLeadProductGroups
          }
        });
        this.$toast.success(`Products changed `);
        this.updatingProducts = false;
      } catch (error) {
        this.$toast.error(`Failed to change products: ${error.message}`);
        this.updatingProducts = false;
      }
    },
    handleProductChange() {
      setTimeout(() => {
        this.productsChangeHandler();
      }, 1);
    }
  }
};
</script>
<style scoped>
.stage-container {
  text-align: center;
}
.stage-container h1 {
  line-height: 1;
}

.stage-column {
  display: flex;
  justify-content: flex-end;
}
.stage-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stage-wrapper h1 {
  line-height: 1;
}

.stage-wrapper h6 {
  color: lightgray;
  text-transform: uppercase;
  font-weight: bold;
}

.nba-wrapper {
  text-align: center;
}
</style>
